import { useGaCplEventTracker as gaCplEventTracker } from "./ga-tracker/ga-events-tracker";
import { cplOptInLyticsEventTracker } from "./lytics-tracker/lytics-tracker";
import { CplEventAction } from "./utils";

interface CplEventsTracker {
  action: CplEventAction;
  cplName: string;
  email: string;
  value?: number | null;
}

export function cplEventsTracker({
  action,
  cplName,
  email,
  value,
}: CplEventsTracker) {
  if (email) {
    cplOptInLyticsEventTracker(cplName, email, action);
  }
  gaCplEventTracker()(cplName, action, value);
}
